<ng-template #loadingGeneral>

  <mat-spinner class="center"></mat-spinner>
  <p class="center">Loading...</p>

</ng-template>

<ng-template #loadingItem>
  <mat-progress-bar class="center" mode="indeterminate"></mat-progress-bar>
</ng-template>

<div fxLayout="column">


  <ng-container *ngIf="dataSource; else loadingGeneral">

    <div class="w-100 mb-1" fxLayout="row" fxLayoutAlign="center center">

      <mat-form-field *ngIf="dataSource.data.length > 1" class="mb-0">
        <mat-label>Search</mat-label>
        <input #input (keyup)="applyFilters(input.value)" matInput placeholder="">
      </mat-form-field>
      <span fxFlex></span>
    </div>

    <!-- <mat-progress-bar *ngIf="loading" class="center" mode="indeterminate"></mat-progress-bar> -->
    <table (matSortChange)="doSortItems($event)" [dataSource]="dataSource" class="w-100 mat-elevation-z2" mat-table
      matSort multiTemplateDataRows>


      <ng-container matColumnDef="idSetup">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Id Setup </th>
        <td *matCellDef="let element" mat-cell>{{element.id}}</td>
      </ng-container>
      <ng-container matColumnDef="company">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Company </th>
        <td *matCellDef="let element" mat-cell>{{element.contract.company.companyName}}</td>
      </ng-container>
      <ng-container matColumnDef="contractDescription">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Contract Description </th>
        <td *matCellDef="let element" mat-cell>{{element.contract.description}}</td>
      </ng-container>
      <ng-container matColumnDef="refContract">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Reference Contract </th>
        <td *matCellDef="let element" mat-cell>{{element.identifier}}</td>
      </ng-container>
      <ng-container matColumnDef="contractBoxNumbers">
        <th *matHeaderCellDef mat-header-cell mat-sort-header> Box Numbers </th>
        <td *matCellDef="let element" mat-cell>{{element.contract.numberOfBoxes}}</td>
      </ng-container>
      <!-- Contract Type Column -->
      <ng-container matColumnDef="contractType">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Contract Type</th>
        <td *matCellDef="let element" mat-cell class="uppercase"> {{element.contract.thirdPartyContract ?
          contractTypes.partnership : contractTypes.directContract | splitCamelCase}} </td>
      </ng-container>
      <!-- Start Date Column -->
      <ng-container matColumnDef="startDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Start Date</th>
        <td *matCellDef="let element" mat-cell> {{element.contract.startDate | date:"dd/MM/yyyy"}} </td>
      </ng-container>
      <!-- End Date Column -->
      <ng-container matColumnDef="endDate">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>End Date</th>
        <td *matCellDef="let element" mat-cell> {{element.contract.endDate | date:"dd/MM/yyyy"}} </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th *matHeaderCellDef mat-header-cell></th>
        <td mat-cell *matCellDef="let element" class="text-right">
          <button *ngIf="(loggedUser.role === roles.admin)" [disabled]="disabled" (click)="updateBillingSetup(element)"
            mat-icon-button matTooltip="Edit Setup">
            <mat-icon>edit</mat-icon>
          </button>
          <button *ngIf="!(loggedUser.role === roles.admin)" [disabled]="disabled" (click)="updateBillingSetup(element)"
            mat-icon-button matTooltip="Show details">
            <mat-icon>visibility</mat-icon>
          </button>
          <button (click)="deleteBillingSetup(element)" [disabled]="!(loggedUser.role === roles.admin)" mat-icon-button
            matTooltip="Delete Setup">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>


      <tr mat-header-row *matHeaderRowDef="headers"></tr>
      <tr mat-row *matRowDef="let row; columns: headers;"></tr>

      <tr *matNoDataRow class="mat-row">
        <td [colSpan]="headers.length" class="mat-cell text-center">
          No billing items found
        </td>
      </tr>

    </table>
  </ng-container>

  <mat-paginator #paginatorItems [fxShow]="dataSource && dataSource.data.length > 10" [pageSizeOptions]="[5, 10, 20]"
    [pageSize]="10" class="mat-elevation-z1" showFirstLastButtons></mat-paginator>
</div>